"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMM_LP_FEE = exports.ADD_LIQUIDITY_URLS = exports.AMM_SUBGRAPH_URLS = exports.getAmmByFactory = exports.AMM_FACTORY = exports.hrAmms = exports.Amms = void 0;
const types_1 = require("./types");
var Amms;
(function (Amms) {
    Amms["uniswap"] = "uniswap";
    Amms["quickswap"] = "quickswap";
    Amms["satin"] = "satin";
    Amms["sushiswap"] = "sushiswap";
    Amms["swapr"] = "swapr";
    Amms["swapfish"] = "swapfish";
    Amms["zyberswap"] = "zyberswap";
    Amms["arbidex"] = "arbidex";
    Amms["solidlizard"] = "solidlizard";
    Amms["ramses"] = "ramses";
    Amms["auragi"] = "auragi";
    Amms["chronos"] = "chronos";
    Amms["pangolin"] = "pangolin";
    Amms["traderJoe"] = "traderJoe";
    Amms["flair"] = "flair";
    Amms["glacier"] = "glacier";
    Amms["solarbeam"] = "solarbeam";
    Amms["thorus"] = "thorus";
    Amms["tetuswap"] = "tetuswap";
    Amms["solidly"] = "solidly";
    Amms["solidlyB"] = "solidlyB";
    Amms["solidlyUSDC"] = "solidlyUSDC";
    Amms["solidlyUSDCB"] = "solidlyUSDCB";
    Amms["solidly091"] = "solidly091";
    Amms["solidlyOxd"] = "solidlyOxd";
    Amms["velocimeter"] = "velocimeter";
    Amms["velocore"] = "velocore";
    Amms["draculafi"] = "draculafi";
    Amms["vesync"] = "vesync";
    Amms["solunea"] = "solunea";
    Amms["pearl"] = "pearl";
    Amms["pearlStable"] = "pearlStable";
    Amms["thruster"] = "thruster";
    Amms["fenix"] = "fenix";
    Amms["fenixStable"] = "fenixStable";
    Amms["aerodrome"] = "aerodrome";
    Amms["aeroStable"] = "aeroStable";
    Amms["aeroStable1"] = "aeroStable1";
    Amms["merchantmoe"] = "merchantmoe";
    Amms["tokan"] = "tokan";
    Amms["tokan1"] = "tokan1";
    Amms["tokanStable"] = "tokanStable";
    Amms["scale"] = "scale";
    Amms["scaleStable"] = "scaleStable";
    Amms["equalizer"] = "equalizer";
    Amms["equalizerStable"] = "equalizerStable";
    Amms["wigoswap"] = "wigoswap";
    Amms["velodrome"] = "velodrome";
    Amms["alien"] = "alien";
    Amms["shadow"] = "shadow";
    Amms["nile"] = "nile";
    Amms["nileStable"] = "nileStable";
    Amms["swapx"] = "swapx";
})(Amms = exports.Amms || (exports.Amms = {}));
exports.hrAmms = {
    [Amms.uniswap]: 'Uniswap',
    [Amms.quickswap]: 'QuickSwap',
    [Amms.satin]: 'Satin',
    [Amms.pearl]: 'Pearl',
    [Amms.pearlStable]: 'Pearl Stable',
    [Amms.sushiswap]: 'SushiSwap',
    [Amms.swapr]: 'Swapr',
    [Amms.swapfish]: 'SwapFish',
    [Amms.zyberswap]: 'ZyberSwap',
    [Amms.arbidex]: 'Arbidex',
    [Amms.solidlizard]: 'SolidLizard',
    [Amms.ramses]: 'Ramses',
    [Amms.auragi]: 'Auragi',
    [Amms.chronos]: 'Chronos',
    [Amms.pangolin]: 'Pangolin',
    [Amms.traderJoe]: 'TraderJoe',
    [Amms.flair]: 'Flair',
    [Amms.glacier]: 'Glacier',
    [Amms.solarbeam]: 'Solarbeam',
    [Amms.thorus]: 'Thorus',
    [Amms.tetuswap]: 'TetuSwap',
    [Amms.solidly]: 'Solidly',
    [Amms.solidlyB]: 'Solidly',
    [Amms.solidlyUSDC]: 'Solidly',
    [Amms.solidlyUSDCB]: 'Solidly',
    [Amms.solidly091]: 'Solidly',
    [Amms.solidlyOxd]: 'Solidly',
    [Amms.velocimeter]: 'Velocimeter',
    [Amms.velocore]: 'Velocore',
    [Amms.draculafi]: 'DraculaFi',
    [Amms.vesync]: 'VeSync',
    [Amms.solunea]: 'Solunea',
    [Amms.fenix]: 'Fenix',
    [Amms.fenixStable]: 'Fenix Stable',
    [Amms.thruster]: 'Thruster',
    [Amms.aerodrome]: 'Aerodrome',
    [Amms.aeroStable]: 'Aerodrome Stable',
    [Amms.aeroStable1]: 'Aerodrome Stable',
    [Amms.scale]: 'Equalizer Scale',
    [Amms.scaleStable]: 'Scale Stable',
    [Amms.merchantmoe]: 'MerchantMoe',
    [Amms.tokan]: 'Tokan',
    [Amms.tokan1]: 'Tokan',
    [Amms.tokanStable]: 'Tokan Stable',
    [Amms.equalizer]: 'Equalizer',
    [Amms.equalizerStable]: 'Equalizer',
    [Amms.wigoswap]: 'Wigoswap',
    [Amms.velodrome]: 'Velodrome',
    [Amms.alien]: 'AlienBase',
    [Amms.shadow]: 'Shadow',
    [Amms.nile]: 'Nile',
    [Amms.nileStable]: 'Nile Stable',
    [Amms.swapx]: 'SwapX',
};
exports.AMM_FACTORY = {
    [types_1.Networks.Ropsten]: {
        [Amms.uniswap]: '0x5c69bee701ef814a2b6a3edd4b1652cb9cc5aa6f',
    },
    [types_1.Networks.Mainnet]: {
        [Amms.uniswap]: '0x5c69bee701ef814a2b6a3edd4b1652cb9cc5aa6f',
    },
    [types_1.Networks.Polygon]: {
        [Amms.quickswap]: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32',
        [Amms.satin]: '0xCaF3Fb1b03F1D71A110167327f5106bE82beE209',
        [Amms.pearl]: '0xb07c75e3db03eb69f047b92274019912014ba78e',
        [Amms.pearlStable]: '0xFB8Bd40C0a13D141b26eE190Ca87991Ec54932E9',
        [Amms.sushiswap]: '0xc35dadb65012ec5796536bd9864ed8773abc74c4',
        [Amms.tetuswap]: '0x684d8c187be836171a1Af8D533e4724893031828',
    },
    [types_1.Networks.Arbitrum]: {
        [Amms.sushiswap]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
        [Amms.swapr]: '0x359F20Ad0F42D75a5077e65F30274cABe6f4F01a',
        [Amms.swapfish]: '0x71539D09D3890195dDa87A6198B98B75211b72F3',
        [Amms.zyberswap]: '0xac2ee06a14c52570ef3b9812ed240bce359772e7',
        [Amms.arbidex]: '0x1c6e968f2e6c9dec61db874e28589fd5ce3e1f2c',
        [Amms.solidlizard]: '0x734d84631f00dc0d3fcd18b04b6cf42bfd407074',
        [Amms.ramses]: '0x78a2251f1aaeaa8fc1eafcc379663cca3f894708',
        [Amms.auragi]: '0x268bb0220aB61Abd9BD42C5Db49470bb3E6B0b2F',
        [Amms.chronos]: '0x111eEEb6bfAb9e8d0E87E45DB15031d89846e5d7',
        [Amms.solunea]: '0x6ef065573cd3fff4c375d4d36e6ca93cd6e3d499',
    },
    [types_1.Networks.Avalanche]: {
        [Amms.pangolin]: '0xefa94DE7a4656D787667C749f7E1223D71E9FD88',
        [Amms.traderJoe]: '0x9Ad6C38BE94206cA50bb0d90783181662f0Cfa10',
        [Amms.flair]: '0x634e02EB048eb1B5bDDc0CFdC20D34503E9B362d',
        [Amms.glacier]: '0xaC7B7EaC8310170109301034b8FdB75eCa4CC491',
        [Amms.thorus]: '0xa98ea6356A316b44Bf710D5f9b6b4eA0081409Ef',
    },
    [types_1.Networks.Moonriver]: {
        [Amms.sushiswap]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
        [Amms.solarbeam]: '0x049581aEB6Fe262727f290165C29BDAB065a1B68',
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [Amms.solidly]: '0x95887654d8646c26fab33f344576e2e74b211256',
        [Amms.solidlyB]: '0x8610Dc1912a55761a713D827a1a1ad131bE8f579',
        [Amms.solidlyUSDC]: '0xF14f98E6F34C12Bd74fcEAC1668aF749fc269cFf',
        [Amms.solidlyUSDCB]: '0x9B1434a02Ee86302d463bB6B365EbdFAc56e067A',
        [Amms.solidly091]: '0xdc4baf3b4b1df79083eedf3e46ec2c4ec1296f60',
        [Amms.solidlyOxd]: '0xB83D21F60B73B21506c69DEcdBcF7Ab5AB737eB2',
        [Amms.equalizer]: '0xc6366efd0af1d09171fe0ebf32c7943bb310832a',
        [Amms.wigoswap]: '0xC831A5cBfb4aC2Da5ed5B194385DFD9bF5bFcBa7',
    },
    [types_1.Networks.Canto]: {
        [Amms.velocimeter]: '0x1c813cdd6daece2cb83c52f0798504e42816e9c5', //NOTICE: this is actually the staked LP factory
    },
    [types_1.Networks.ZksyncEra]: {
        [Amms.velocore]: '0x36BbDb0DEA4Aa211Dd76dF0a3201c89FD530851b',
        [Amms.draculafi]: '0x68e03d7b8b3f9669750c1282ad6d36988f4fe18e',
        [Amms.vesync]: '0xCF3CAD85885254CBD445d6511c502Da095863f11', //NOTICE: this is actually the staked LP factory
    },
    [types_1.Networks.Blast]: {
        [Amms.thruster]: '',
        [Amms.fenix]: '0xa19C51D91891D3DF7C13Ed22a2f89d328A82950f',
        [Amms.fenixStable]: '0x77AB0B61E2994Dd5c62E578E23E409681E3bA42f',
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Mantle]: {
        [Amms.merchantmoe]: "0x5bEf015CA9424A7C07B68490616a4C1F094BEdEc"
    },
    [types_1.Networks.Base]: {
        [Amms.aerodrome]: '0x420DD381b31aEf6683db6B902084cB0FFECe40Da',
        [Amms.aeroStable]: '0x8f50a6d5ea6715f878E2984569975e8875eeBafB',
        [Amms.aeroStable1]: '0x9111b8D7Cc1a676A70015BEA3A3a9968A44C52c3',
        [Amms.scale]: '0xEd8db60aCc29e14bC867a497D94ca6e3CeB5eC04',
        [Amms.scaleStable]: '0xcCaF24B406A1733F626E3848Aa794cF79F6E33d4',
        [Amms.uniswap]: '0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6',
        [Amms.alien]: '0x3E84D913803b02A4a7f027165E8cA42C14C0FdE7'
    },
    [types_1.Networks.Scroll]: {
        [Amms.tokan]: '0x074568F090e93194289c2C2BF285eE7f60b485a9',
        [Amms.tokan1]: '0x3e35933C468ECEca9748DD1C5FADeFfe64158777',
        [Amms.tokanStable]: '0x6c041ff2d25310a2751C57555265F2364CaCA195', //NOTICE: this is actually the staked LP factory
    },
    [types_1.Networks.Optimism]: {
        [Amms.velodrome]: '0xF1046053aa5682b4F9a81b5481394DA16BE5FF5a',
    },
    [types_1.Networks.Real]: {
        [Amms.pearl]: '0x2B965fDf04f9e9bEEf1659464Ef3A0094A68D923',
        [Amms.pearlStable]: '0x28E22D8c807b6E6c0ECa4373fC3B9920453cEEEe',
    },
    [types_1.Networks.Sonic]: {
        [Amms.equalizer]: '0xDDD9845Ba0D8f38d3045f804f67A1a8B9A528FcC',
        [Amms.equalizerStable]: '0xDDD9845Ba0D8f38d3045f804f67A1a8B9A528FcC',
        [Amms.shadow]: '0x2dA25E7446A70D7be65fd4c053948BEcAA6374c8',
        [Amms.swapx]: '0xB84bbA16A3a332Ac2e66Aa4508db1eFD300CdE2b',
    },
    [types_1.Networks.Linea]: {
        [Amms.nile]: '0xcbdf792456367a91708c0036e0678ecfb1f09654',
        [Amms.nileStable]: '0xb037874de77e7b4505261301d2f3ce2fb9036ca7',
    }
};
function getAmmByFactory(network, address) {
    if (!address)
        return null;
    for (const amm of Object.keys(Amms)) {
        if (exports.AMM_FACTORY[network][amm] &&
            address.toLowerCase() == exports.AMM_FACTORY[network][amm].toLowerCase())
            return amm;
    }
    return null;
}
exports.getAmmByFactory = getAmmByFactory;
exports.AMM_SUBGRAPH_URLS = {
    [types_1.Networks.Ropsten]: {},
    [types_1.Networks.Mainnet]: {
        [Amms.uniswap]: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
    },
    [types_1.Networks.Polygon]: {
        [Amms.quickswap]: 'https://api.thegraph.com/subgraphs/name/sameepsi/quickswap06',
        //[Amms.satin]: "",
        //[Amms.pearl]: "",
        [Amms.sushiswap]: 'https://api.thegraph.com/subgraphs/name/sushiswap/matic-exchange',
        [Amms.tetuswap]: 'https://api.thegraph.com/subgraphs/name/tetu-io/tetu-swap',
    },
    [types_1.Networks.Arbitrum]: {
        [Amms.sushiswap]: 'https://api.thegraph.com/subgraphs/name/sushiswap/arbitrum-exchange',
        [Amms.swapr]: 'https://api.thegraph.com/subgraphs/name/luzzif/swapr-arbitrum-one-v2',
        [Amms.zyberswap]: 'https://api.thegraph.com/subgraphs/name/zyberswap-arbitrum/zyber-amm',
        //[Amms.arbidex]: '',
        [Amms.solidlizard]: 'https://api.thegraph.com/subgraphs/name/solidlizardfinance/sliz',
        //[Amms.ramses]: '',
        //[Amms.auragi]: '',
        //[Amms.chronos]: '',
        //[Amms.swapfish]: 'https://bsc.streamingfast.io/subgraphs/name/pancakeswap/exchange-v2',
    },
    [types_1.Networks.Avalanche]: {
        [Amms.pangolin]: 'https://api.thegraph.com/subgraphs/name/dasconnor/pangolin-dex',
        [Amms.traderJoe]: 'https://api.thegraph.com/subgraphs/name/traderjoe-xyz/exchange',
        [Amms.flair]: '',
        [Amms.glacier]: '',
        [Amms.thorus]: '',
    },
    [types_1.Networks.Moonriver]: {
        [Amms.sushiswap]: 'https://api.thegraph.com/subgraphs/name/sushiswap/moonriver-exchange',
        [Amms.solarbeam]: 'https://analytics.solarbeam.io/api/subgraph',
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [Amms.solidly]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.solidlyB]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.solidlyUSDC]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.solidlyUSDCB]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.solidly091]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.solidlyOxd]: 'https://api.thegraph.com/subgraphs/name/spartacus-finance/solidly',
        [Amms.wigoswap]: 'https://gateway.thegraph.com/api/031cf65e6bf1e03a781f69aeba9770d2/subgraphs/id/ykYhkpzjz9FpT4RZRgFHQ84udU1581pfs4u9KcbA4yt'
    },
    [types_1.Networks.Canto]: {},
    [types_1.Networks.ZksyncEra]: {},
    [types_1.Networks.Blast]: {},
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [Amms.aerodrome]: '',
        [Amms.uniswap]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/4jGhpKjW4prWoyt5Bwk1ZHUwdEmNWveJcjEyjoTZWCY9',
    },
    [types_1.Networks.Mantle]: {},
    [types_1.Networks.Scroll]: {},
    [types_1.Networks.Real]: {},
    [types_1.Networks.Optimism]: {},
    [types_1.Networks.Sonic]: {},
    [types_1.Networks.Linea]: {},
};
exports.ADD_LIQUIDITY_URLS = {
    [types_1.Networks.Ropsten]: {
        [Amms.uniswap]: 'https://app.uniswap.org/#/add/V2/',
    },
    [types_1.Networks.Mainnet]: {
        [Amms.uniswap]: 'https://app.uniswap.org/#/add/V2/',
    },
    [types_1.Networks.Polygon]: {
        [Amms.quickswap]: 'https://quickswap.exchange/#/add/',
        [Amms.satin]: 'https://satin.exchange/liquidity/',
        [Amms.pearl]: 'https://www.pearl.exchange/liquidity/manage/',
        [Amms.pearlStable]: 'https://www.pearl.exchange/liquidity/manage/',
        [Amms.sushiswap]: 'https://app.sushi.com/legacy/add/',
        [Amms.tetuswap]: 'https://swap.tetu.io/#/add/',
    },
    [types_1.Networks.Arbitrum]: {
        [Amms.sushiswap]: 'https://app.sushi.com/legacy/add/',
        [Amms.swapr]: 'https://swapr.eth.link/#/add/',
        [Amms.swapfish]: 'https://swapfish.fi/add/',
        [Amms.zyberswap]: 'https://app.zyberswap.io/exchange/add/',
        [Amms.arbidex]: 'https://arbidex.fi/add/',
        [Amms.solidlizard]: 'https://solidlizard.finance/liquidity/',
        [Amms.ramses]: 'https://app.ramses.exchange/liquidity/',
        [Amms.auragi]: 'https://auragi.finance/pools/create?address=',
        [Amms.chronos]: 'https://app.chronos.exchange/liquidity/',
        [Amms.solunea]: 'https://www.solunea.xyz/liquidity/',
    },
    [types_1.Networks.Avalanche]: {
        [Amms.pangolin]: 'https://app.pangolin.exchange/#/add/',
        [Amms.traderJoe]: 'https://www.traderjoexyz.com/#/pool/',
        [Amms.flair]: 'https://app.flairdex.xyz/liquidity/',
        [Amms.glacier]: 'https://www.glacier.exchange/liquidity/',
        [Amms.thorus]: 'https://app.thorus.fi/add/',
    },
    [types_1.Networks.Moonriver]: {
        [Amms.sushiswap]: 'https://app.sushi.com/legacy/add/',
        [Amms.solarbeam]: 'https://app.solarbeam.io/exchange/add/',
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [Amms.solidly]: 'https://solidly.exchange/liquidity/',
        [Amms.solidlyB]: 'https://solidly.exchange/liquidity/',
        [Amms.solidlyUSDC]: 'https://solidly.exchange/liquidity/',
        [Amms.solidlyUSDCB]: 'https://solidly.exchange/liquidity/',
        [Amms.solidly091]: 'https://solidly.exchange/liquidity/',
        [Amms.solidlyOxd]: 'https://solidly.exchange/liquidity/',
        [Amms.equalizer]: 'https://equalizer.exchange/liquidity/',
        [Amms.wigoswap]: 'https://wigoswap.io/farms/',
    },
    [types_1.Networks.Canto]: {
        [Amms.velocimeter]: 'https://www.velocimeter.xyz/liquidity/',
    },
    [types_1.Networks.ZksyncEra]: {
        [Amms.velocore]: 'https://app.velocore.xyz/liquidity/',
        [Amms.draculafi]: 'https://draculafi.xyz/liquidity/',
        [Amms.vesync]: 'https://app.vesync.finance/liquidity/',
    },
    [types_1.Networks.Blast]: {
        [Amms.thruster]: 'https://app.thruster.finance/add',
        [Amms.fenix]: 'https://www.fenixfinance.io/liquidity/deposit',
        [Amms.fenixStable]: 'https://www.fenixfinance.io/liquidity/deposit',
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [Amms.aerodrome]: 'https://aerodrome.finance/deposit/',
        [Amms.aeroStable]: 'https://aerodrome.finance/deposit/',
        [Amms.scale]: 'https://base.equalizer.exchange/liquidity/',
        [Amms.uniswap]: 'https://app.uniswap.org/#/add/V2/',
    },
    [types_1.Networks.Mantle]: {
        [Amms.merchantmoe]: 'https://merchantmoe.com/pool/',
    },
    [types_1.Networks.Scroll]: {
        [Amms.tokan]: 'https://app.tokan.exchange/liquidity/',
        [Amms.tokanStable]: 'https://app.tokan.exchange/liquidity/',
    },
    [types_1.Networks.Optimism]: {
        [Amms.velodrome]: 'https://velodrome.finance/deposit/',
    },
    [types_1.Networks.Real]: {
        [Amms.pearlStable]: 'https://www.pearl.exchange/supply-liquidity/v2/',
        [Amms.pearl]: 'https://www.pearl.exchange/supply-liquidity/v2/',
    },
    [types_1.Networks.Sonic]: {
        [Amms.equalizer]: 'https://equalizer.exchange/liquidity/',
        [Amms.equalizerStable]: 'https://equalizer.exchange/liquidity/',
        [Amms.shadow]: 'https://www.shadow.so/liquidity/',
        [Amms.swapx]: 'https://swapx.fi/earn/'
    },
    [types_1.Networks.Linea]: {
        [Amms.nile]: 'https://www.nile.build/manage/v1/',
        [Amms.nileStable]: 'https://www.nile.build/manage/v1/'
    },
};
exports.AMM_LP_FEE = {
    [types_1.Networks.Ropsten]: {
        [Amms.uniswap]: 0.003,
    },
    [types_1.Networks.Mainnet]: {
        [Amms.uniswap]: 0.003,
    },
    [types_1.Networks.Polygon]: {
        [Amms.quickswap]: 0.0025,
        [Amms.satin]: 0,
        [Amms.pearl]: 0,
        [Amms.pearlStable]: 0,
        [Amms.sushiswap]: 0.0025,
        [Amms.tetuswap]: 0,
    },
    [types_1.Networks.Arbitrum]: {
        [Amms.sushiswap]: 0.0025,
        [Amms.swapr]: 0.00225,
        [Amms.swapfish]: 0.0017,
        [Amms.zyberswap]: 0.0015,
        [Amms.arbidex]: 0,
        [Amms.solidlizard]: 0,
        [Amms.ramses]: 0,
        [Amms.auragi]: 0,
        [Amms.chronos]: 0,
        [Amms.solunea]: 0,
    },
    [types_1.Networks.Avalanche]: {
        [Amms.pangolin]: 0.0025,
        [Amms.traderJoe]: 0.0025,
        [Amms.flair]: 0,
        [Amms.glacier]: 0,
        [Amms.thorus]: 0,
    },
    [types_1.Networks.Moonriver]: {
        [Amms.sushiswap]: 0.0025,
        [Amms.solarbeam]: 0.002,
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [Amms.solidly]: 0,
        [Amms.solidlyB]: 0,
        [Amms.solidlyUSDC]: 0,
        [Amms.solidlyUSDCB]: 0,
        [Amms.solidly091]: 0,
        [Amms.solidlyOxd]: 0,
        [Amms.equalizer]: 0,
        [Amms.wigoswap]: 0.003,
    },
    [types_1.Networks.Canto]: {
        [Amms.velocimeter]: 0,
    },
    [types_1.Networks.ZksyncEra]: {
        [Amms.velocore]: 0,
        [Amms.draculafi]: 0,
        [Amms.vesync]: 0,
    },
    [types_1.Networks.Blast]: {
        [Amms.thruster]: 0.003,
        [Amms.fenix]: 0,
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [Amms.aerodrome]: 0,
        [Amms.aeroStable]: 0,
        [Amms.scale]: 0,
        [Amms.uniswap]: 0.003,
    },
    [types_1.Networks.Scroll]: {
        [Amms.tokan]: 0,
        [Amms.tokanStable]: 0,
    },
    [types_1.Networks.Mantle]: {
        [Amms.merchantmoe]: 0.003,
    },
    [types_1.Networks.Optimism]: {
        [Amms.velodrome]: 0,
    },
    [types_1.Networks.Real]: {
        [Amms.pearlStable]: 0,
        [Amms.pearl]: 0,
    },
    [types_1.Networks.Sonic]: {
        [Amms.equalizer]: 0,
        [Amms.equalizerStable]: 0,
        [Amms.shadow]: 0,
        [Amms.swapx]: 0
    },
    [types_1.Networks.Linea]: {
        [Amms.nile]: 0,
        [Amms.nileStable]: 0
    },
};
